import React, { useEffect, useState } from "react";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import { useAlert } from "react-alert";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Stack,
  Avatar,
  CircularProgress,
} from "@mui/material";
import {
  DatePicker,
  GenderSelector,
  InputLabel,
  InputTextField,
  SumbitButton,
  Title,
  UserEmail,
  UserName,
  ProfileImage,
  CameraIcon,
} from "./profile.components";

import { imageUploadfunc, updateUserProfile } from "../../services/profile";
import ProfileBg from "../../images/proifle-icon-bg.png";
import "./profile.css";
import { useCookies } from "react-cookie";

function Profile({ isData, profileData, setProfileData }) {
  const alert = useAlert();
  const [cookies] = useCookies();
  const [firstNameValue, setFirstNameValue] = useState("");
  const [lastNameValue, setLastNameValue] = useState("");
  const [birthday, setBirthday] = useState(null);
  const [genderValue, setGenderValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [phoneValue, setPhoneValue] = useState("");
  const [addressValue, setAddressValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [imageValue, setImageValue] = useState("");
  const [imageLoader, setImageLoader] = useState(false);

  useEffect(() => {
    displayData();
  }, [isData]);

  async function handleImageUpload(e) {
    setImageLoader(true);
    let formDataBanner = new FormData();

    formDataBanner.append("file", e.target.files[0]);
    var resp = await imageUploadfunc(formDataBanner);
    // console.log(resp.url);
    setImageValue(resp.url);
    setImageLoader(false);
  }

  const handleSubmit = async () => {
    if (validate()) {
      const updatedData = {
        emailID: emailValue,
        firstName: firstNameValue,
        lastName: lastNameValue,
        phoneNumber: phoneValue,
        image: imageValue,
        birthday: birthday,
        gender: genderValue,
        address: addressValue,
        city: cityValue,
        state: stateValue,
      };

      await updateUserProfile(cookies, updatedData)
        .then((response) => {
          // console.log(response);
          if (response.data !== null) {
            alert.success(response.message);
            setProfileData(response.data);
          }
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <OuterWrapper sx={{ bgcolor: "#F8FBFE", pt: "100px", pb: "40px" }}>
      <InnerWrapper>
        <Stack
          direction={{ xs: "column-reverse", sm: "row" }}
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2.5}
          mx={1.25}
        >
          {ProfileForm()}
          <ProfilePicture />
        </Stack>
      </InnerWrapper>
    </OuterWrapper>
  );

  function ProfileForm() {
    return (
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={3.5}
        sx={{
          bgcolor: "#EAEEF2",
          px: 4.5,
          pt: 6,
          pb: 2.5,
        }}
      >
        <Title>General Information</Title>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={{ xs: 2, md: 10 }}
          sx={{ width: "100%" }}
        >
          <Box sx={{ width: "100%" }}>
            <InputLabel>First name</InputLabel>
            <InputTextField
              label="Enter your first name"
              value={firstNameValue}
              setValue={setFirstNameValue}
              type="text"
            />
          </Box>
          <Box sx={{ width: "100%" }}>
            <InputLabel>Last name</InputLabel>
            <InputTextField
              label="Enter your last name"
              value={lastNameValue}
              setValue={setLastNameValue}
              type="text"
            />
          </Box>
        </Stack>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={{ xs: 2, md: 10 }}
          sx={{ width: "100%" }}
        >
          <Box sx={{ width: "100%" }}>
            <InputLabel>Birthday</InputLabel>
            <DatePicker value={birthday} setValue={setBirthday} />
          </Box>
          <Box sx={{ width: "100%" }}>
            <InputLabel>Gender</InputLabel>
            <GenderSelector value={genderValue} setValue={setGenderValue} />
          </Box>
        </Stack>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={{ xs: 2, md: 10 }}
          sx={{ width: "100%" }}
        >
          <Box sx={{ width: "100%" }}>
            <InputLabel>Email</InputLabel>
            <InputTextField
              label="Name@gmail.com"
              value={emailValue}
              setValue={setEmailValue}
              type="email"
            />
          </Box>
          <Box sx={{ width: "100%" }}>
            <InputLabel>Phone number</InputLabel>
            <InputTextField
              label="9876543210"
              value={phoneValue}
              setValue={setPhoneValue}
            />
          </Box>
        </Stack>
        <Box sx={{ width: "100%" }}>
          <InputLabel>Address</InputLabel>
          <InputTextField
            label="Enter your home address"
            value={addressValue}
            setValue={setAddressValue}
            address={880}
          />
        </Box>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={{ xs: 2, md: 10 }}
          sx={{ width: "100%" }}
        >
          <Box sx={{ width: "100%" }}>
            <InputLabel>City</InputLabel>
            <InputTextField
              label="City"
              value={cityValue}
              setValue={setCityValue}
            />
          </Box>
          <Box sx={{ width: "100%" }}>
            <InputLabel>State</InputLabel>
            <InputTextField
              label="State"
              value={stateValue}
              setValue={setStateValue}
            />
          </Box>
        </Stack>
        <SumbitButton onClick={handleSubmit}>Save</SumbitButton>
      </Stack>
    );
  }

  function ProfilePicture() {
    return (
      <Box sx={{ width: { xs: "100%", sm: 320, md: 376 } }}>
        <Card>
          <CardMedia
            component="img"
            src={ProfileBg}
            alt=""
            sx={{ height: 193 }}
          />
          <CardContent
            sx={{ position: "relative", height: 259, bgcolor: "#EAEEF2" }}
          >
            <ProfileImage
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                <>
                  {imageLoader ? (
                    <CircularProgress />
                  ) : (
                    <label htmlFor="contained-button-file">
                      <input
                        accept="image/*"
                        type="file"
                        id="contained-button-file"
                        onChange={handleImageUpload}
                        style={{ display: "none" }}
                      />
                      <CameraIcon />
                    </label>
                  )}
                </>
              }
            >
              <Avatar
                alt=""
                src={imageValue}
                sx={{ width: "100%", height: "100%" }}
              />
            </ProfileImage>
            <UserName>{firstNameValue}</UserName>
            <UserEmail>{emailValue}</UserEmail>
          </CardContent>
        </Card>
      </Box>
    );
  }

  function displayData() {
    // console.log(profileData);
    setFirstNameValue(profileData.firstName);
    setLastNameValue(profileData.lastName);
    setBirthday(profileData.birthday || "");
    setGenderValue(profileData.gender);
    setEmailValue(profileData.emailID);
    setPhoneValue(profileData.phoneNumber);
    setAddressValue(profileData.address);
    setCityValue(profileData.city);
    setStateValue(profileData.state);
    setImageValue(profileData.image);
  }

  function validate() {
    const phoneRegex = /^\d{10}$/;

    if (!firstNameValue) {
      alert.error("First Name cannot be empty");
      return false;
    }
    if (!lastNameValue) {
      alert.error("Last Name cannot be empty");
      return false;
    }
    if (!phoneValue || !phoneRegex.test(phoneValue)) {
      alert.error("please enter a valid phone number");
      return false;
    }
    return true;
  }
}

export default Profile;
